import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HomeWorkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"home_work"}/>
}
